<template>
  <div style="position: relative;">
    <div class="login" data-v-37dfd6fc="" data-track-uuid="d8ebd317-7166-ed0c-ec81-0d8e165dace0">
     <div style="background: rgb(255, 255, 255) none repeat scroll 0% 0%;" data-v-37dfd6fc="">
      <div class="logo" data-v-6e24d36a="" data-v-37dfd6fc="">
       <img src="../../assets/images/FjcCn2rtFf-h6r2pt--N4DGfkY7a.png" alt="" data-v-6e24d36a="" />
       <div class="title" data-v-6e24d36a="">
        创作者服务平台
       </div>
      </div>
     </div>
     <div class="content" data-v-37dfd6fc="">
      <div class="login-form" data-v-37dfd6fc="">
       <div class="title" data-v-37dfd6fc="">
        账户登录
       </div>
       <form class="ant-form ant-form-horizontal" data-v-37dfd6fc="">
         <el-input :placeholder="$t('login.username')" v-model="username" @keypress.native.enter="login" class="input-login"></el-input>
         <el-input :placeholder="$t('login.password')" v-model="password" @keypress.native.enter="login" class="input-login" type="password" style="margin-top: 20px;"></el-input>
         <el-input :placeholder="$t('login.verify_code')" v-model="code" @keypress.native.enter="login" class="input-login" style="margin-top: 20px; background: none;">
           <!-- <template slot="prepend"><i class="el-icon-view"></i></template> -->
           <template slot="append">
             <verify-code :identifyCode="verify_code" @getCode="getCode()" style="position: absolute; right: 0; top: 0;"></verify-code>
           </template>
         </el-input>
         <!-- <el-input placeholder="请输入密码" v-model="password" show-password></el-input> -->
         <div class="login-btn" @click="login" v-text="$t('login.btn')" style="width: 100%; height: 40px; background-color: #00C6C6; color: #fff; border-radius: 5px; text-align: center; line-height: 40px; margin-top: 20px; cursor: pointer;"></div>
       </form>
       <div style="text-align: right; margin-top: -8px;" data-v-37dfd6fc="">
        <!---->
        <!-- <span class="codeHelp" data-v-37dfd6fc="">收不到验证码？</span> -->
       </div>
       <div class="tips" data-v-37dfd6fc="">
         登录即同意
        <a data-v-37dfd6fc="" @click="showTrip(0)" one-link-mark="yes">用户协议</a> 和
        <a data-v-37dfd6fc="" @click="showTrip(1)" one-link-mark="yes">隐私政策</a> 首次登录将自动注册
       </div>
      </div>
     </div>
     <div class="footer" data-v-37dfd6fc="">
      <p>上海识装信息科技有限公司</p>
      <p>Shanghai Shizhuang Information Technology Co., Ltd</p>
      <p> 增值电信业务经营许可证 沪B2-20180281 <a rel="noopener noreferrer" one-link-mark="yes"> 沪ICP备16013780号-9号 </a> 网络文化经营许可证 沪网文 （2018）6057-334号 <a rel="noopener noreferrer" one-link-mark="yes"> 沪公网安备310109020012982号 </a><img src="../../assets/images/Fm9PaS-qnEFv2dfAS4YXppxLlbo_.png" alt="" width="12" /></p>
      <p><a class="link" rel="noopener noreferrer" one-link-mark="yes"> 廉政举报 </a><a class="link" rel="noopener noreferrer" one-link-mark="yes"> 隐私政策 </a><a class="link" rel="noopener noreferrer" one-link-mark="yes"> 使用条款 </a><a class="link" rel="noopener noreferrer" one-link-mark="yes"> 知识产权 </a><a class="link" rel="noopener noreferrer" one-link-mark="yes"> 加入我们 </a></p>
      <div class="iconBox">
       <a class="aIcon" rel="noopener noreferrer" one-link-mark="yes"><img src="../../assets/images/TGFyazIwMjAwMzAzLTE0Mzc0NDE1ODMyMTc0ODYyNzQ.png" alt="" /></a>
       <a class="aIcon" rel="noopener noreferrer" one-link-mark="yes"><img src="../../assets/images/Fvvg1TFzJiV-nt7vjaUNkoXyRrRw.png" alt="" /></a>
       <a class="aIcon" rel="noopener noreferrer" one-link-mark="yes"><img src="../../assets/images/FnklCR3V-WFYYEc6o_eCAGzJ6m08.png" alt="" /></a>
       <a class="aIcon" rel="noopener noreferrer" one-link-mark="yes"><img src="../../assets/images/FlE1Cnap9CWLYAnzGyvMmg_5apWT.png" alt="" /></a>
      </div>
      <p style="margin-top: 6px;"> 社区内容举报电话：021-63066366（工作时间：8:00-19:00） </p>
      <p>2016-2020 识装版权所有</p>
     </div>
     <!---->
    </div>

    <el-dialog
      :title="trip_title"
      :visible.sync="dialogVisible"
      width="70%">
       <iframe :src="trip_url" style="width: 100%; height: 500px;"></iframe>
    </el-dialog>

  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      checked: true,
      username: '',
      password: '',
      code: '',
      verify_code: '',
      languare: 'CN',
      dialogVisible: false,
      trip_title: '得物创作服务平台账号用户协议',
      trip_url: ''
    };
  },
  created() {
    // this.languare = 'CN';
    // const lang = localStorage.lang || 'cn';
    // this.languare = lang === 'en' ? 'EN' : 'CN';
    if (sessionStorage.getItem('token')) {
      this.$router.push({ path: '/' });
    }
    this.getCode();
  },
  beforeCreate() {
    if (this.$route.query.token) {
      this.$http.post('/trader/login/login', {
        token: this.$route.query.token
      }).then(res => {
        if (res.code === 200) {
          window.location.href = '/';
        } else {
          this.$router.push({ path: '/login' });
        }
      });
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    showTrip(index) {
      const title = ['得物创作服务平台账号用户协议', '得物创作服务平台账号隐私政策'];
      const url = ['https://fast.dewu.com/nezha-plus/detail/5f8571e03c3f9d77f3aff086', 'https://m.dewu.com/hybird/h5other/agreement-secret'];
      this.trip_url = url[index];
      this.trip_title = title[index];
      this.dialogVisible = true;
    },
    login(formName) {
      if (this.username === '') {
        this.$message.error(this.$t('login.username_verify'));
        return false;
      }
      if (this.password === '') {
        this.$message.error(this.$t('login.password_verify'));
        return false;
      }
      if (this.code === '') {
        this.$message.error(this.$t('login.code_null'));
        return false;
      }
      if (this.code.toLowerCase() !== this.verify_code.toLowerCase()) {
        this.$message.error(this.$t('login.code_verify'));
        this.getCode();
        return false;
      }
      this.$http.post('/trader/login/doLogin', {
        username: this.username,
        password: this.password
      })
        .then(res => {
          if (res.code === 200) {
            this.$router.push({ path: '/' });
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getCode() {
      const str = '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKMNOPQRSTUVWXYZ';
      const codes = str.split('');
      const arr = [];
      for (let i = 0; i < 4; i++) { // 从0-61之间取随机数
        const index = Math.floor(Math.random() * (58 - 0 + 1) + 0);
        const char = codes[index];
        arr.push(char);
      }
      this.verify_code = arr.join('');
    }
  },
  watch: {
    'languare'(val) {
      this.$i18n.locale = val === 'EN' ? 'en' : 'cn';
      localStorage.setItem('lang', val === 'EN' ? 'en' : 'cn');
    }
  },
  components: { VerifyCode: resolve => require(['./Components/VerifyCode.vue'], resolve) }
};
</script>
<style lang="less" scoped>
  .box-card {
    position: absolute;
    z-index: 9999;
    width: 280px;
    height: 320px;
    top: 100px;
    right: 120px;
    border-radius: 15px;
    background: rgba(0, 0, 0, .4);
    border: none;
    .header-login {
      width: 100%;
      height: 60px;
      color: #D3D7F7;
      font-size: 20px;
    }
    .login-btn {
      width: 100%;
      height: 40px;
      margin-top: 20px;
      border: 1px solid #D3D7F7;
      border-radius: 5px;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      background: #00C6C6;
    }
  }
  * {
    margin: 0;
    padding: 0;
  }
  ul {
    list-style: none;
  }
  button,
  input,
  select,
  textarea {
    margin: 0;
  }
  button,
  input,
  select,
  a,
  img {
    outline: none;
  }
  html {
    /* 默认正常盒模型 */
    box-sizing: content-box;
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
    outline: none;
  }
  img,
  embed,
  object,
  audio {
    height: auto;
    max-width: 100%;
  }
  iframe {
    border: 0;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  td,
  th {
    padding: 0;
    text-align: left;
  }
  body {
    font-family: "PingFang SC", Helvetica, "思源黑体 CN Normal", Tahoma, Arial, DengXian, "Microsoft YaHei", Simsun, SimHei, sans-serif;
    line-height: 1;
  }
  p {
    line-height: 1;
  }
  a {
    color: #000;
    cursor: pointer;
    text-decoration: none;
  }
  html,
  body {
    background: #f8f8f8;
  }
  body {
    margin: 0;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    font-variant: tabular-nums;
    line-height: 1.5715;
    background-color: #fff;
    font-feature-settings: 'tnum';
  }
  [tabindex='-1']:focus {
    outline: none !important;
  }

p {
    margin-top: 0;
    margin-bottom: 1em;
  }
  /**
  * @全局变量
  */
  .logo[data-v-6e24d36a] {
    display: flex;
    align-items: center;
    margin: 0 15px;
    height: 64px;
    line-height: 64px;
    overflow: hidden;
    white-space: nowrap;
  }
  .logo img[data-v-6e24d36a] {
    height: 40px;
    margin-right: 8px;
  }
  .logo .title[data-v-6e24d36a] {
    color: #000;
    font-size: 20px;
    font-weight: 500;
  }
  .footer {
    height: 275px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    width: 100%;
    background: #000;
    color: #aaaabb;
    font-size: 12px;
  }
  .footer p {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-bottom: 6px;
  }
  .footer a {
    color: #aaaabb;
    font-size: 12px;
  }
  .link {
    padding: 0 14px;
  }
  .iconBox {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .aIcon {
    display: block;
    width: 67px;
    height: 34px;
  }
  .aIcon:nth-child(1) {
    display: block;
    width: 67px;
    height: 34px;
  }
  .aIcon:nth-child(1) img {
    height: 100%;
  }
  .aIcon:nth-child(2) {
    width: 67px;
    height: 34px;
    margin-left: 36px;
  }
  .aIcon:nth-child(3) {
    width: 67px;
    height: 26px;
    margin-left: 36px;
  }
  .aIcon:nth-child(4) {
    margin-left: 36px;
  }
  .aIcon :global(img) {
    width: 100%;
    height: 100%;
  }
  .login .content[data-v-37dfd6fc] {
    width: 100%;
    height: calc(100vh - 64px);
    position: relative;
    background: url(../../assets/images/80a0bd6059894bd83bc5fc77cb18d65e.png) no-repeat center;
    background-size: cover;
    background-color: #000;
  }
  .login-form[data-v-37dfd6fc] {
    position: absolute;
    top: 188px;
    right: 76px;
    width: 300px;
    padding: 24px 24px 12px;
    background: #fff;
    border-radius: 2px;
    z-index: 100;
  }
  .login-form .title[data-v-37dfd6fc] {
    margin-bottom: 24px;
    font-size: 20px;
    line-height: 24px;
    color: #2c2c3c;
  }
  .login-form[data-v-37dfd6fc] .ant-input-group-addon {
    width: 99px !important;
    cursor: pointer;
  }
  .login-form[data-v-37dfd6fc] .ant-form-item {
    margin-bottom: 18px;
  }
  .login-form[data-v-37dfd6fc] .ant-form-item-with-help {
    margin-bottom: 0;
  }
  .codeHelp[data-v-37dfd6fc] {
    font-size: 12px;
    color: #a8a7ae;
    cursor: pointer;
  }
  .tips[data-v-37dfd6fc] {
    margin-top: 30px;
    text-align: center;
    color: #a8a7ae;
    font-size: 12px;
  }
  .tips a[data-v-37dfd6fc] {
    color: #0ac2c3;
    text-decoration: underline;
  }
</style>
